import { Pipe, PipeTransform } from '@angular/core';

/**
 * Extracts label name strings from the label_ids dictionary format
 * used by assessments ({ id: name } or array format).
 *
 * Usage: `assessment.label_ids | labelNames`
 */
@Pipe({ name: 'labelNames' })
export class LabelNamesPipe implements PipeTransform {
  transform(labelIds: Record<string, string> | unknown[] | null | undefined): string[] {
    if (!labelIds) return [];

    if (typeof labelIds === 'object' && !Array.isArray(labelIds)) {
      return Object.values(labelIds as Record<string, string>).filter(
        (name): name is string => !!name && typeof name === 'string'
      );
    }

    if (Array.isArray(labelIds)) {
      return labelIds
        .map(item => {
          if (typeof item === 'object' && item !== null) {
            const values = Object.values(item as Record<string, string>);
            return values.length > 0 ? values[0] : undefined;
          }
          return typeof item === 'string' ? item : undefined;
        })
        .filter((name): name is string => !!name);
    }

    return [];
  }
}
